import React from "react"
import Dot from "./Dot"



export default function ThirdFace(){
   return(
        <div className="dice third-face">
            <Dot />
            <Dot />
            <Dot />
        </div>
   ) 
}